// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JwL67","fullView":"styles_fullView__CBGMj"};